import React, {useState, useEffect} from 'react'
import { useDispatch } from 'react-redux';
import { setIsLoggedIn } from '../../../../features/account/account.slice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const SubscriptionInfo = ({userSubscriptionData, openModal, convertFromSecondToLowercase}) => {

    const [subscriptionStatus, setSubscriptionStatus] = useState(null);

    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    const dispatch = useDispatch();

    const updateSubscriptionStatus = async (newStatus) => {
        try {
            const response = await fetch(`${apiUrl}/subscription/update-subscription-status`, {
                method: 'PUT',
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ newStatus })
            })

            if (response.status === 401) {
                // Unauthorized, possibly session expired
                dispatch(setIsLoggedIn(false)); // Redux update will clear user data and redirect to login
                return;
            };

            const responseData = await response.json();

            if (responseData.success) {
                setSubscriptionStatus(newStatus);
            } else {
                console.error('Failed to update subscription status:', responseData.message);
            }
        }
        catch (error) {
            console.error('Error updating subscription status:', error);
        }
    }

    // Check if subscription has expired
    const checkExpiration = (exp) => {
        const currentDate = new Date();
        const [year, month, day] = exp.split('-').map(Number);
        let expirationDate = new Date(year, month - 1, day);
        return currentDate > expirationDate;
    }

    useEffect(() => {

        if (!userSubscriptionData) {
            // No subscription data available
        } else if (checkExpiration(userSubscriptionData.expirationDate) && userSubscriptionData.subscriptionStatus === 'ACTIVE') {
            // setSubscriptionStatus(userSubscriptionData.subscriptionStatus);
            updateSubscriptionStatus('EXPIRED');
        } else {
            setSubscriptionStatus(userSubscriptionData.subscriptionStatus);
        }
    }, [userSubscriptionData]);

    return (
        <div className='p-4 mt-3 rounded col-10 col-md-8 col-lg-6' style={{border: "1px solid #AEAFBA"}}>
            <div className='d-flex'>
                <h3>Subscription</h3>
                {/* button that says status of subscription */}
                {subscriptionStatus && (
                    <div
                    className="d-flex align-items-center ms-3 mt-1 px-2 py-1 text-center justify-content-center"
                    style={{
                        borderRadius: "50px", // Elliptical border
                        backgroundColor: subscriptionStatus === "ACTIVE" ? "#28a745" : "#dc3545", // Green for active, red for all other statuses
                        color: "white", // Text color
                        fontSize: "12px", // Font size
                        fontWeight: "bold", // Bold text
                        height: "28px", // Fixed height for consistent size
                        minWidth: "80px", // Minimum width for consistent size
                        maxWidth: "120px", // Maximum width for longer statuses
                    }}
                    >
                        {convertFromSecondToLowercase(subscriptionStatus)}
                    </div>
                )}
            </div>
            <div className='d-flex justify-content-between align-items-center' style={{cursor: "pointer"}}>
                <div>
                <p className='m-0' style={{fontSize: "15px"}}>Access Plan</p>
                <p className='m-0' style={{fontWeight: 300}}>{userSubscriptionData ? userSubscriptionData.subscriptionType.split("")[0] + " Month Access" : "None"}</p>
                {userSubscriptionData?.expirationDate && (
                <p className='m-0' style={{fontSize: "12px", color: "#AEAFBA"}}>Expires on {userSubscriptionData.expirationDate}</p>
                )}
                {!userSubscriptionData || subscriptionStatus === 'EXPIRED' && (
                <p className='m-0' style={{fontSize: "15px"}}><span>subscribe</span> to gain access</p>
                )}
                </div>
                <FontAwesomeIcon
                icon={faChevronRight}
                style={{ cursor: "pointer", color: "#AEAFBA", cursor: "pointer" }}
                onClick={() => openModal('invoices')}
                />    
            </div>
        </div>
    )
}

export default SubscriptionInfo
